// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__FQT-n {
    display: flex;
    flex-direction: column;
    margin: var(--container-margin) auto 0;
    width: calc(950px + var(--container-padding) * 2);
    padding: 0 var(--container-padding);
    max-width: 100%;
}

.styles_container__FQT-n h1 {
    margin-bottom: 35px;
}

.styles_sectionWrapper__c\\+kQr {
    width: 1090px;
    max-width: 100%;
    max-height: calc(100vh - 270px);
    margin-bottom: 40px;
    background: #fff;
    padding: 0 35px;
    border: 0.5px solid var(--dark-grey);
}

.styles_table__obmxu {
    width: 100%;
}

.styles_table__obmxu th,
.styles_table__obmxu thead th:not(:first-child) {
    position: sticky;
    top: 0;
    background: #fff;
    padding-top: 14px;
}

.styles_table__obmxu th:after {
    content: '';
    display: block;
    border-top: 1px solid var(--dark-grey);
    height: 8px;
    position: absolute;
    bottom: -8px;
    width: 100%;
    left: 0;
}

.styles_table__obmxu th:not(:first-child):not(:last-child):after {
    left: 10px;
    width: calc(100% - 20px);
}

/*.table th:first-child:after {*/
/*    left: 0;*/
/*}*/

/*.table th:last-child:after {*/
/*    margin-right: -10px;*/
/*}*/

.styles_table__obmxu td {
    font-size: 14px;
    padding: 10px 10px;
}

.styles_table__obmxu td:first-child {
    text-align: center;
}

.styles_table__obmxu tr:not(:last-child) td {
    border-bottom: 1px solid var(--light-grey);
}

.styles_definition__8kYDC {
    text-align: left;
    white-space: pre-line;
}

.styles_decryption__5xHue {
    width: 290px;
}

.styles_term__Gm2Ca {
    width: 135px;
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Glossary/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,sCAAsC;IACtC,iDAAiD;IACjD,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,sCAAsC;IACtC,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,OAAO;AACX;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA,gCAAgC;AAChC,eAAe;AACf,IAAI;;AAEJ,+BAA+B;AAC/B,2BAA2B;AAC3B,IAAI;;AAEJ;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    margin: var(--container-margin) auto 0;\n    width: calc(950px + var(--container-padding) * 2);\n    padding: 0 var(--container-padding);\n    max-width: 100%;\n}\n\n.container h1 {\n    margin-bottom: 35px;\n}\n\n.sectionWrapper {\n    width: 1090px;\n    max-width: 100%;\n    max-height: calc(100vh - 270px);\n    margin-bottom: 40px;\n    background: #fff;\n    padding: 0 35px;\n    border: 0.5px solid var(--dark-grey);\n}\n\n.table {\n    width: 100%;\n}\n\n.table th,\n.table thead th:not(:first-child) {\n    position: sticky;\n    top: 0;\n    background: #fff;\n    padding-top: 14px;\n}\n\n.table th:after {\n    content: '';\n    display: block;\n    border-top: 1px solid var(--dark-grey);\n    height: 8px;\n    position: absolute;\n    bottom: -8px;\n    width: 100%;\n    left: 0;\n}\n\n.table th:not(:first-child):not(:last-child):after {\n    left: 10px;\n    width: calc(100% - 20px);\n}\n\n/*.table th:first-child:after {*/\n/*    left: 0;*/\n/*}*/\n\n/*.table th:last-child:after {*/\n/*    margin-right: -10px;*/\n/*}*/\n\n.table td {\n    font-size: 14px;\n    padding: 10px 10px;\n}\n\n.table td:first-child {\n    text-align: center;\n}\n\n.table tr:not(:last-child) td {\n    border-bottom: 1px solid var(--light-grey);\n}\n\n.definition {\n    text-align: left;\n    white-space: pre-line;\n}\n\n.decryption {\n    width: 290px;\n}\n\n.term {\n    width: 135px;\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__FQT-n`,
	"sectionWrapper": `styles_sectionWrapper__c+kQr`,
	"table": `styles_table__obmxu`,
	"definition": `styles_definition__8kYDC`,
	"decryption": `styles_decryption__5xHue`,
	"term": `styles_term__Gm2Ca`
};
export default ___CSS_LOADER_EXPORT___;
